import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Grid,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@mui/material';
import { useTheme } from '@mui/system';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import ApiHelper from 'utils/apiHelper';
import { gridSpacing } from 'utils/constants';
import ReportFileExports from 'components/Reports/FileExports';

const DeviceTypeDevicesDialog = ({ onClose, groupId, policyId, deviceType, columnIndex, groupsData, policiesData, selectedStatements }) => {
    const theme = useTheme();
    const [devicesData, setDevicesData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtersData, setFiltersData] = useState([]);

    useEffect(() => {
        setLoading(true);
        ApiHelper.post('/api/reports/devices_type_devices/', {
            group_id: groupId === 0 ? '' : groupId.toString(),
            policy_id: policyId === 0 ? '' : policyId.toString(),
            pie: deviceType,
            slice: columnIndex,
            statement: selectedStatements.length > 0 ? selectedStatements : []
        })
            .then((res) => {
                setLoading(false);
                setDevicesData(res.data);
                toast.success('Successfully done');
                let groupName = 'Any';
                let policyName = 'Any';
                for (let i = 0; i < groupsData.length; i++) {
                    if (groupsData[i].id === groupId) {
                        groupName = groupsData[i].name;
                    }
                }
                for (let i = 0; i < policiesData.length; i++) {
                    if (policiesData[i].id === policyId) {
                        policyName = policiesData[i].name;
                    }
                }
                const temp = [
                    { label: 'Group Name', value: groupName },
                    { label: 'Policy Name', value: policyName },
                    { label: 'Device Category', value: columnIndex }
                ];
                setFiltersData(temp);
            })
            .catch(() => {
                setLoading(false);
                toast.warning('There is no data');
            });
    }, [columnIndex, deviceType, groupId, groupsData, policiesData, policyId, selectedStatements]);

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '16px' }}>Show Devices</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <Grid container spacing={gridSpacing}>
                        {devicesData.length > 0 && (
                            <Grid item xs={12}>
                                <ReportFileExports
                                    elementId="deviceTypeDevicesData"
                                    reportTitle="Devices"
                                    downloadFileName="device_type_devices"
                                    downloadFileOption="all"
                                    data={devicesData}
                                    headers={[
                                        { label: 'Device Name', key: 'name' },
                                        { label: 'MAC Address', key: 'mac' },
                                        { label: 'IP Address', key: 'ipv4' },
                                        { label: deviceType === 'os' ? 'Operating System' : 'Device Type', key: 'usage' }
                                    ]}
                                    filtersData={filtersData}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <Paper sx={{ overflowX: 'auto' }}>
                                {loading === true ? (
                                    <Typography sx={{ mt: 3, textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}>
                                        Please wait...
                                    </Typography>
                                ) : devicesData.length === 0 ? (
                                    <Typography sx={{ textAlign: 'center', mt: 3 }} color={theme.palette.secondary.main}>
                                        No data to show the devices
                                    </Typography>
                                ) : (
                                    <Table id="deviceTypeDevicesData">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Device Name</TableCell>
                                                <TableCell>MAC Address</TableCell>
                                                <TableCell>IP Address</TableCell>
                                                <TableCell>{deviceType === 'os' ? 'Operating System' : 'Device Type'}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {devicesData.map((data, key) => (
                                                <TableRow key={key}>
                                                    <TableCell>{data.name}</TableCell>
                                                    <TableCell>{data.mac}</TableCell>
                                                    <TableCell>{data.ipv4}</TableCell>
                                                    <TableCell>{columnIndex}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                )}
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                {loading === false && (
                    <Button onClick={onClose} color="primary" variant="contained">
                        OK
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

DeviceTypeDevicesDialog.propTypes = {
    onClose: PropTypes.func,
    groupId: PropTypes.number,
    policyId: PropTypes.number,
    deviceType: PropTypes.string,
    columnIndex: PropTypes.string,
    groupsData: PropTypes.array,
    policiesData: PropTypes.array,
    selectedStatements: PropTypes.array
};

export default DeviceTypeDevicesDialog;
